import React from "react";
import ComicBase from "../ComicBase";

export default function ComicNaruto() {
  return (
    <ComicBase
      titulo="BATSU GAME de Yankee Onna ni Kokuttemita parte 2"
      portada="https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-1.jpg"
  paginas={[
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-2.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-3.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-4.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-5.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-6.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-7.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-8.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-9.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-10.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-11.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-12.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-13.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-14.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-15.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-16.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-17.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-18.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-19.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-20.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-21.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-22.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-23.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-24.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-25.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-26.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-27.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-28.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-29.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-30.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-31.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-32.jpg",
  "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-33.jpg"
]}
      sugeridos={[]}


      info={{
  grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "original",
    personajes: [""],
etiquetas: ["Big Ass", "Big Breasts", "Big Penis", "Bikini", "Blowjob", "C93", "Freckles", "Impregnation", "Multi-work Series", "Nakadashi", "Netorare", "Paizuri", "Ponytail", "Sole Female", "Sole Male", "Swimsuit", "Tall Girl", "X-Ray"],    artistas: "Fuetakishi",
      }}
    />
  );
}

export const infoManga = {
  titulo: "BATSU GAME de Yankee Onna ni Kokuttemita parte 2",
  portada: "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-1.jpg",
  reverso: "https://fullcomics18.org/img9/batsu-game-de-yankee-onna-ni-kokuttemita2-3.jpg",
        fecha:"2026-05-9", // 👈 MOVER AQUÍ


  info: {
   grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "original",
    personajes: [""],
etiquetas: ["Big Ass", "Big Breasts", "Big Penis", "Bikini", "Blowjob", "C93", "Freckles", "Impregnation", "Multi-work Series", "Nakadashi", "Netorare", "Paizuri", "Ponytail", "Sole Female", "Sole Male", "Swimsuit", "Tall Girl", "X-Ray"],    artistas: "Fuetakishi",
  },
};
